(function () {
  'use strict';

  function initTakeawayNoticePlacement(root) {
    const scope = root && root.querySelector ? root : document;
    const notice = scope.querySelector('[data-takeaway-notice]') || document.querySelector('[data-takeaway-notice]');
    if (!notice) return;

    const product = document.getElementById('product-' + notice.dataset.takeawayProductId);
    const primary = product && product.querySelector('[data-takeaway-notice-primary]');
    const gallery = product && product.querySelector('[data-product-gallery]');
    const detailsLayout = document.querySelector('[data-product-description-layout]');
    const alternate = detailsLayout && detailsLayout.querySelector('[data-takeaway-notice-alternate]');
    const standalone = document.querySelector('[data-takeaway-notice-standalone][data-product-id="' + notice.dataset.takeawayProductId + '"]');
    const stacked = standalone && standalone.querySelector('[data-takeaway-notice-stacked]');
    const information = product && product.querySelector('.product__section-right > div');
    const informationColumn = information && information.parentElement;
    if (!primary || !gallery || !stacked || !information) return;

    document.querySelectorAll('[data-takeaway-notice]').forEach((existingNotice) => {
      if (existingNotice === notice || existingNotice.dataset.takeawayProductId !== notice.dataset.takeawayProductId) return;
      if (typeof existingNotice.takeawayNoticeCleanup === 'function') existingNotice.takeawayNoticeCleanup();
      existingNotice.remove();
    });

    if (typeof notice.takeawayNoticeCleanup === 'function') notice.takeawayNoticeCleanup();
    let resizeTimer;
    let observer;

    const moveNotice = () => {
      const galleryRect = gallery.getBoundingClientRect();
      const informationRect = informationColumn.getBoundingClientRect();
      const productColumnsAreSideBySide = galleryRect.left < informationRect.left &&
        galleryRect.right <= informationRect.left + 1 &&
        Math.abs(galleryRect.top - informationRect.top) < 4;
      const noticeStyle = window.getComputedStyle(notice);
      const noticeOuterHeight = notice.getBoundingClientRect().height +
        (parseFloat(noticeStyle.marginTop) || 0) +
        (parseFloat(noticeStyle.marginBottom) || 0);
      const informationHeight = information.scrollHeight +
        (primary.contains(notice) ? 0 : noticeOuterHeight);
      const galleryHeight = galleryRect.height;
      const moveBesideDescription = productColumnsAreSideBySide && alternate && informationHeight > galleryHeight + 2;
      const destination = productColumnsAreSideBySide ? (moveBesideDescription ? alternate : primary) : stacked;

      if (!destination.contains(notice)) destination.appendChild(notice);
      if (detailsLayout) detailsLayout.classList.toggle('has-takeaway-notice', Boolean(moveBesideDescription));
    };

    const schedulePlacement = () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(moveNotice, 80);
    };

    moveNotice();
    window.addEventListener('resize', schedulePlacement, { passive: true });
    if ('ResizeObserver' in window) {
      observer = new ResizeObserver(schedulePlacement);
      observer.observe(gallery);
      observer.observe(information);
      observer.observe(notice);
    }
    notice.takeawayNoticeCleanup = () => {
      window.clearTimeout(resizeTimer);
      window.removeEventListener('resize', schedulePlacement);
      if (observer) observer.disconnect();
    };
  }

  function init(root) {
    initTakeawayNoticePlacement(root || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
}());
